module.exports = __webpack_public_path__ + "static/media/theme.2ffba3d3.svg";